import React, { useContext } from 'react'
import MUIDataTable from "mui-datatables";
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { GlobalContext } from '../context/global_context';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTable: {
        styleOverrides: {
          root: {
            borderRadius: '30px !important',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: '#3c6218 !important',

            color: 'white'
          },
        },
      },
    },
  });

const DataTable = (dataInfo) => {

  const { data, columns, title } = dataInfo;
  const { setFiltro, setFiltro2, setFiltroUser, setAcuse, setFiltroLeida, searchText, setSearchText } = useContext(GlobalContext)
  const permiso = localStorage.getItem('EXPORTACIÓN');

  const normalizeText = (value) =>
    String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const flattenValue = (value) => {
    if (value == null) return "";
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      return String(value);
    }
    if (Array.isArray(value)) {
      return value.map((item) => flattenValue(item)).join(" ");
    }
    if (typeof value === "object") {
      return Object.values(value)
        .map((item) => flattenValue(item))
        .join(" ");
    }
    return String(value);
  };

  const buildSearchableText = (row) => {
    if (!row || typeof row !== "object") return "";
    return flattenValue(row);
  };

  const searchableData = (data ?? []).map((row) => ({
    ...row,
    searchableText: buildSearchableText(row),
  }));

  const mergedColumns = [
    ...columns,
    {
      name: "searchableText",
      label: "",
      options: {
        display: "excluded",
        filter: false,
        sort: false,
        download: false,
        viewColumns: false,
      },
    },
  ];

  const customSearch = (searchQuery, currentRow) => {
    const normalizedSearchQuery = normalizeText(searchQuery);

    if (!normalizedSearchQuery) return true;

    return currentRow.some((cell) => {
      const searchable = flattenValue(cell);
      return normalizeText(searchable).includes(normalizedSearchQuery);
    });
  };

  const options = {
    selectableRows: 'none',
    search: true,
    tableBodyHeight: 'auto',
    searchText,
    customSearch,
    searchOpen: false,
    onTableChange: (action, tableState) => {
      if (action === 'search') {
        setSearchText(tableState.searchText);
      }
    },
    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
        toolTip: "Clasificar",
        columnHeaderTooltip: (column) => `Clasificar por ${column.label}`
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtrar tabla",
      },
      filter: {
        all: "Todo",
        title: "Filtros",
        reset: "Restaurar",
      },
      viewColumns: {
        title: "Ver columnas",
        titleAria: "Mostrar/Ocultar columnas en la tabla",
      },
      selectedRows: {
        text: "columna(s) selecciona(as)",
        delete: "Eliminar",
        deleteAria: "Eliminar filas seleccionadas",
      },
    },

    downloadOptions: {
      filename: title + '.csv',
      utf8WithBom: false,
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },

    download: permiso ? true : false,

    print: false,
    viewColumns: false,
    onFilterChipClose: (e) => {
      setFiltro('')
      setFiltro2('')
      setFiltroUser('')
      setAcuse('')
      setFiltroLeida('')
    }
  };

  return (

    <Box sx={{ flexGrow: 2 }}>
      <Grid className='container mt-3 mb-3' maxWidth="xl">
        <ThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            title={title}
            data={searchableData}
            columns={mergedColumns}
            options={options}
          />
        </ThemeProvider>
      </Grid>
    </Box>
  );
}

export default DataTable;